import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import notifications from "../common/Components/Notifications/Notification";
import { sendProblemReport } from "./clientErrorReporter";

type Props = { isOpen: boolean; onClose: () => void };

/** "Report a problem": one optional line from the user; the page and recent errors go with it. */
const ReportProblemDialog = ({ isOpen, onClose }: Props) => {
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);

  const close = () => {
    if (sending) return;
    setNote("");
    onClose();
  };

  const submit = async () => {
    setSending(true);
    const reference = await sendProblemReport(note);
    setSending(false);
    if (reference) {
      notifications({ title: "Sent", message: `Thank you. Reference ${reference}.`, type: "success", duration: 4000 });
      setNote("");
      onClose();
    } else {
      notifications({ title: "Could not send", message: "Please try again in a few minutes.", type: "danger" });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={close} centered>
      <ModalHeader toggle={close}>Report a problem</ModalHeader>
      <ModalBody>
        <label htmlFor="hkp-report-note" className="form-label">
          What went wrong? (optional)
        </label>
        <textarea
          id="hkp-report-note"
          className="form-control"
          rows={3}
          maxLength={500}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="For example: the photo did not save"
        />
        <small className="text-muted d-block mt-2">
          We send this page's address and the last few errors. Please don't type phone numbers or ID numbers.
        </small>
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={close} disabled={sending}>
          Cancel
        </Button>
        <Button color="primary" onClick={submit} disabled={sending}>
          {sending ? "Sending…" : "Send"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReportProblemDialog;
